import React from 'react';
import DashboardContainer from './containers/DashboardContainer';
import EnvBadge from './components/EnvBadge';

function App() {
  return (
    <>
      <EnvBadge />
      <DashboardContainer />
    </>
  );
}

export default App;
